import { zod } from '@acme/core'
import { z } from 'zod'
import ApiService from '../api.service'

export type Cidade = z.infer<typeof zod.CidadeSchema>

export const cidade = new ApiService<Cidade>('cidades')
